<template>
  <div id="app">
    <router-view :user="user"/>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { db } from './main'

export default {
  name: 'App',
  beforeCreate: function () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let that = this
        that.user = user
        that.user.superAdmin = false
        that.user.adminUser = false
        that.user.storeGroup = ''
        that.user.userGroup = 'normal'
        that.user.ready = false

        db.collection('user').doc(user.uid).get().then((doc) => {
          if (doc.exists) {
            // user already recorded or will go catch
            // console.log('recorded user found => adminUser => ', doc.data().adminUser)
            that.user.superAdmin = doc.data().superAdmin ? true : false
            that.user.adminUser = doc.data().adminUser
            if (that.user.adminUser) {
              that.user.storeGroup = doc.data().storeGroup
            }
            that.user.userGroup = doc.data().userGroup
            that.user.ready = true
          } else {
            return db.collection('user').doc(user.uid).set({
              uid: user.uid,
              email: user.email,
              adminUser: false,
              userGroup: 'normal'
            }).then(doc => {
              // console.log('new user added into the data base')
            })
          }
        }).catch(err => {
          // doc doesn't exist, register the user into database
          // console.log('error while retriving user data', err)
        })
      }
    })
  },
  data () {
    return {
      user: null
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
